/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from "react";
import styled from "styled-components";
// import { useNavigate } from "react-router-dom";
import * as MatStyled from "@mui/material/styles";

import font from "src/styles/font";
import { checkNotEmpty } from "src/common";

import {
  Stack,
  // Alert,
  Box,
} from "@mui/material";
import MuiStepper from "@mui/material/Stepper";
import MuiStep from "@mui/material/Step";
import MuiStepLabel from "@mui/material/StepLabel";
import MuiStepContent from "@mui/material/StepContent";
import Button from "src/components/core/Button";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import useModal from "src/hooks/useModal";
import { UseUpload } from "src/context/UploadProductContext";
import { useSteps } from "src/hooks/useStep";
import { useAuth } from "src/hooks/useAuth";

// import Loading from "src/components/ui/Loading";
import PreviewDialog from "src/modules/product/upload/modal/PreviewDialog";

import Step1 from "src/modules/product/upload/Step1";
import Step2 from "src/modules/product/upload/Step2";

const Stepper = styled(MuiStepper)`
  &.MuiStepper-root {
    /* max-height: 100%; */
    width: 100%;
    /* max-width: 1240px; */
    position: relative;
    margin: 0 auto;
    height: 100%;
    max-height: calc(100% - 100px);
  }

  .MuiStepConnector-root {
    flex: 0;
  }
  .MuiStepConnector-line {
    min-height: 0;
  }
`;

const Step = styled(MuiStep)`
  &.MuiStep-root {
    max-height: calc(100% - 60px);
  }
`;

const StepLabel = styled(MuiStepLabel)`
  width: 100%;
  min-height: 60px;
  position: relative;
  background-color: var(--white-color);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.10); */
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 10;

  &.MuiStepLabel-root {
    padding: 16px 40px;
  }
  .MuiStepLabel-labelContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .MuiStepLabel-label {
    color: var(--secondary-color);
    font-size: ${font.size.md};
    font-weight: 400;

    .Mui-active {
      color: var(--secondary-color);
      font-weight: 600;
    }
  }
`;

const StepCount = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: ${font.size.md};
`;

const StepContent = styled(MuiStepContent)`
  &.MuiStepContent-root {
    width: 100%;
    /* max-width: 1240px; */
    max-height: calc(100% - 60px);
    margin: 0;
    border: none;
    padding: 0;
    /* margin: 0 auto; */
    overflow: hidden;
    overflow-y: scroll;
    scroll-behavior: smooth;
  }
`;

const ButtonGroup = styled(Stack)`
  /* width: 100%;
  max-width: 1240px; */

  width: 100%;
  height: 100px;
  background-color: var(--white-color);
  position: absolute;
  bottom: 0;
  z-index: 15;
  /* margin-top: 24px; */
  padding: 24px 40px;
  border-radius: 24px 24px 0 0;
  box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);

  .MuiButton-root {
    padding: 12px 24px;
    font-size: ${font.size.sm};
  }
`;

const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginTop: "75px",
  width: "100%",
  height: "calc(100vh - 75px)",
  overflow: "hidden",
  // overflowY: "scroll",
  scrollBehavior: "smooth",
  background: "#fff",
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
}));

const WrapStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor: "transparent",
  zIndex: 1,
  color: "#fff",
  width: 30,
  height: 30,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  padding: "1.5px",
  marginLeft: 0,
  ...(ownerState.active && {
    border: "1px dashed var(--primary-color)",
  }),
  // ...(ownerState.completed && {
  //   border: "none",
  // }),
}));

const StepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor: "#9E9E9E",
  zIndex: 1,
  color: "#fff",
  width: 24,
  height: 24,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: 0,
  ...(ownerState.active && {
    backgroundColor: "#9E9E9E",
  }),
  ...(ownerState.completed && {
    backgroundColor: "var(--primary-color)",
  }),
}));

const CreateUploadProduct = ({ open }) => {
  const { user } = useAuth();
  // const navigate = useNavigate();
  const {
    dataUpload,
    dataUploadChoice,
    dataSimilar,
    uploadErrors,
    choiceErrors,
    onCreateButton,
    onSaveEditButton,
    onSaveDraftButton,
  } = UseUpload();
  const { getModalState, open: openModal, close } = useModal();
  const { currentStep, setStep } = useSteps({
    initialStep: 0,
    maxStep: 1,
  });

  const [firstStepValid, setFirstStepValid] = useState({
    validProductCount: 0,
    validChoiceCount: 0,
    allFieldCount: 0,
  });

  // before backward || reload
  useEffect(() => {
    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return (ev.returnValue = "Are you sure you want to close?");
    });
  });

  // set step 1 count all
  useEffect(() => {
    let count = document.getElementsByClassName("form-input");

    setFirstStepValid((prev) => ({
      ...prev,
      allFieldCount: count.length,
    }));
  }, [
    dataUploadChoice.length,
    ...dataUploadChoice.map((choice) =>
      JSON.stringify(choice.group_price.unit_price),
    ),
    ...dataUploadChoice.map((choice) =>
      JSON.stringify(checkNotEmpty(choice.group_price.sample_price)),
    ),
    ...dataUploadChoice.map((choice) =>
      JSON.stringify(checkNotEmpty(choice.group_price.install_price)),
    ),
    ...dataUploadChoice.map((choice) =>
      JSON.stringify(checkNotEmpty(choice.pre_order_date)),
    ),
    ...dataUploadChoice.map((choice) => JSON.stringify(choice.is_instock)),
    dataUpload?.product_tisi,
  ]);

  const productField = [
    "user_id",
    "brand",
    "item_name",
    "item_code",
    "category",
    "product_types",
    "suitable_areas",
    "recommend_rooms",
    "product_features",
    "description",
    "similar_admin",
    "similar_seller",
  ];

  const choiceField = [
    "name",
    "color",
    "texture_type",
    "group_price",
    "size",
    "pre_order_date",
    "stock_count",
    "pattern",
    "hashtags",
  ];

  const isSaveDraftValid = [
    "user_id",
    "brand",
    "item_name",
    "item_code",
    "category",
    "product_types",
  ].every((required) => !Object.keys(uploadErrors).includes(required));

  // set step 1 valid product count
  useEffect(() => {
    // console.log("----dataUpload-----", dataUpload);

    let count = 0;

    productField.map((key) => {
      if (key === "user_id") {
        // if (userData?.role_id === 3) count -= 1

        if (user?.role_id === 1 && checkNotEmpty(dataUpload[key])) count += 1;
      } else if (key === "similar_admin") {
        // if (userData?.role_id === 3) count -= 1

        if (user?.role_id === 1 && checkNotEmpty(dataSimilar[key])) count += 1;
      } else if (key === "similar_seller") {
        if (checkNotEmpty(dataSimilar[key])) count += 1;
      } else {
        if (checkNotEmpty(dataUpload[key])) count += 1;
      }

      return count;
    });

    setFirstStepValid((prev) => ({
      ...prev,
      validProductCount: count,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUpload, dataSimilar]);

  // set step 1 valid choice count
  useEffect(() => {
    let count = 0;

    dataUploadChoice.map((choice, i) => {
      choiceField.map((key) => {
        if (key === "group_price" || key === "size") {
          Object.keys(choice[key]).forEach((subKey) => {
            if (
              subKey !== "is_start_price" &&
              subKey !== "quantity" &&
              subKey !== "special_price"
            ) {
              if (
                // subKey === "unit_price" ||
                subKey === "unit_width" ||
                subKey === "unit_height" ||
                subKey === "unit_thickness" ||
                subKey === "unit_capacity"
              ) {
                if (checkNotEmpty(choice[key][subKey])) count += 1;
              } else if (subKey === "unit_price") {
                if (
                  choice[key][`unit_price`]?._id ===
                    "63c90d859d945fef0df81f64" || // litre
                  choice[key][`unit_price`]?._id ===
                    "63c90d859d945fef0df81f67" || // sq.ft.
                  choice[key][`unit_price`]?._id === "63c90d859d945fef0df81f69" // yard
                )
                  count -= 1;
                if (
                  choice[key][`unit_price`]?._id === "63c90d859d945fef0df81f5f"
                )
                  // sqm.
                  count -= 5;

                if (checkNotEmpty(choice[key][subKey])) count += 1;
              } else if (subKey === "install_price") {
                // install_price count only first choice
                if (checkNotEmpty(choice[key][subKey]) && i === 0) count += 1;
              } else {
                if (
                  typeof parseFloat(choice[key][subKey]) === "number" &&
                  parseFloat(choice[key][subKey]) > 0
                )
                  count += 1;
              }
            }
          });
        } else {
          if (checkNotEmpty(choice[key])) count += 1;
        }

        return count;
      });

      return count;
    });

    setFirstStepValid((prev) => ({
      ...prev,
      validChoiceCount: count,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUploadChoice]);

  const [secondStepValid, setSecondStepValid] = useState({
    validCount: 0,
    allFieldCount: 0,
  });

  // set step 2 count all
  useEffect(() => {
    setSecondStepValid((prev) => ({
      ...prev,
      allFieldCount: dataUploadChoice.length * 7,
    }));
  }, [dataUploadChoice.length]);

  // set step 2 valid count
  useEffect(() => {
    let count = 0;

    dataUploadChoice.map(({ group_image }, i) => {
      Object.keys(group_image).forEach((key) => {
        if (checkNotEmpty(group_image[key])) {
          count += 1;
        }
      });

      return count;
    });

    setSecondStepValid((prev) => ({
      ...prev,
      validCount: count,
    }));
  }, [dataUploadChoice]);

  const handleSave = async (btnState) => {
    if (btnState === "draft") {
      try {
        await onSaveDraftButton()
          .then((res) => {
            if (res === "success") {
              setStep(0);
              if (getModalState(`preview-product-modal`)?.isOpen)
                close(`preview-product-modal`);
            }
          })
          .catch((err) => console.log("create err:", err));
      } catch (err) {
        console.log("err:", err);
      }
    } else {
      if (checkNotEmpty(dataUpload?._id)) {
        try {
          await onSaveEditButton()
            .then((res) => {
              if (res === "success") {
                setStep(0);
                close(`preview-product-modal`);
              }
            })
            .catch((err) => console.log("create err:", err));
        } catch (err) {
          console.log("err:", err);
        }
      } else {
        try {
          // await onCreateButton()
          //   .then((res) => {
          //     if (res === "success") {
          //       close(`preview-product-modal`);
          //       navigate(`/product/list`);
          //     }
          //   })
          //   .catch((err) => console.log("create err:", err));
          await onCreateButton();
          close(`preview-product-modal`);
          // navigate(`/product/list`);
        } catch (err) {
          console.log("err:", err);
        }
      }
    }
  };

  const scrollRef = useRef(null);

  const scrollToTop = () => {
    scrollRef.current.scrollTo(0, 0);
  };

  // useEffect(() => {
  //   scrollToTop();
  // }, [currentStep]);

  useEffect(() => {
    if (!!choiceErrors[`choices[0].name`]) {
      scrollToTop();
    }
  }, [choiceErrors]);

  const StepIcon = (props) => {
    const { active, completed, className } = props;

    return (
      <WrapStepIconRoot
        ownerState={{ completed, active }}
        className={className}
      >
        <StepIconRoot ownerState={{ completed, active }} className={className}>
          {String(props.icon)}
        </StepIconRoot>
      </WrapStepIconRoot>
    );
  };

  return (
    <>
      <Main open={open}>
        <Stepper nonLinear activeStep={currentStep} orientation="vertical">
          <Step
            completed={
              firstStepValid.validProductCount +
                firstStepValid.validChoiceCount ===
              firstStepValid.allFieldCount
            }
          >
            <StepLabel
              StepIconComponent={StepIcon}
              optional={
                <StepCount>
                  <Box>
                    {firstStepValid.validProductCount +
                      firstStepValid.validChoiceCount}
                    /{firstStepValid.allFieldCount}
                  </Box>

                  <ArrowDropDownIcon
                    sx={{
                      transform: "rotate(0)",
                      transition: "transform .4s ease",
                      ...(currentStep === 0 && {
                        transform: "rotate(180deg)",
                      }),
                    }}
                  />
                </StepCount>
              }
              onClick={() => (currentStep === 0 ? setStep(1) : setStep(0))}
            >
              รายละเอียดและตัวเลือกสินค้า
            </StepLabel>

            <StepContent ref={scrollRef}>
              <Step1 />
            </StepContent>
          </Step>

          <Step
            completed={
              secondStepValid.validCount === secondStepValid.allFieldCount
            }
          >
            <StepLabel
              StepIconComponent={StepIcon}
              optional={
                <StepCount>
                  <Box>
                    {secondStepValid.validCount}/{secondStepValid.allFieldCount}
                  </Box>

                  <ArrowDropDownIcon
                    sx={{
                      transform: "rotate(0)",
                      transition: "transform .4s ease",
                      ...(currentStep === 1 && {
                        transform: "rotate(180deg)",
                      }),
                    }}
                  />
                </StepCount>
              }
              sx={{
                boxShadow: "0px -4px 4px 0px rgba(0, 0, 0, 0.10)",
                ...(currentStep === 1 && {
                  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.10)",
                }),
              }}
              onClick={() => (currentStep === 1 ? setStep(0) : setStep(1))}
            >
              รูปภาพสินค้า
            </StepLabel>

            <StepContent>
              <Step2 />
            </StepContent>
          </Step>
        </Stepper>

        <ButtonGroup
          flexDirection={"row"}
          justifyContent={"flex-end"}
          alignItems={"center"}
          columnGap={2}
        >
          {!checkNotEmpty(dataUpload?._id) || dataUpload?.status === "draft" ? (
            <Button
              variant="outlined"
              size="large"
              disabled={!isSaveDraftValid}
              onClick={() => handleSave("draft")}
              sx={{
                width: "100%",
                maxWidth: 160,
                borderRadius: 4,
              }}
            >
              บันทึกร่าง
            </Button>
          ) : null}

          <Button
            variant="contained"
            size="large"
            // disabled={formQuotation?.remark?.length > 400}
            onClick={() => openModal(`preview-product-modal`)}
            sx={{ width: "100%", maxWidth: 160, borderRadius: 4 }}
          >
            {dataUpload?._id && dataUpload?.status !== "draft"
              ? "แก้ไขสินค้า"
              : "สร้างสินค้า"}
          </Button>
        </ButtonGroup>
      </Main>

      <PreviewDialog
        isOpen={getModalState(`preview-product-modal`)?.isOpen}
        onClose={() => close(`preview-product-modal`)}
        onSubmit={handleSave}
      />
    </>
  );
};

export default CreateUploadProduct;
